// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DelineateBasinsInput } from "./DelineateBasinsInput";
import {
  DelineateBasinsInputFromJSON,
  DelineateBasinsInputFromJSONTyped,
  DelineateBasinsInputToJSON,
  DelineateBasinsInputToJSONTyped,
} from "./DelineateBasinsInput";
import type { DelineateBasinsOutput } from "./DelineateBasinsOutput";
import {
  DelineateBasinsOutputFromJSON,
  DelineateBasinsOutputFromJSONTyped,
  DelineateBasinsOutputToJSON,
  DelineateBasinsOutputToJSONTyped,
} from "./DelineateBasinsOutput";

/**
 *
 * @export
 * @interface DelineateBasinsSchema
 */
export interface DelineateBasinsSchema {
  /**
   *
   */
  tag: DelineateBasinsSchemaTagEnum;
  /**
   *
   */
  inputs: DelineateBasinsInput;
  /**
   *
   */
  outputs: DelineateBasinsOutput;
}

/**
 * @export
 */
export const DelineateBasinsSchemaTagEnum = {
  DelineateBasins: "delineate_basins",
} as const;
export type DelineateBasinsSchemaTagEnum =
  (typeof DelineateBasinsSchemaTagEnum)[keyof typeof DelineateBasinsSchemaTagEnum];

/**
 * Check if a given object implements the DelineateBasinsSchema interface.
 */
export function instanceOfDelineateBasinsSchema(value: object): value is DelineateBasinsSchema {
  if (!("tag" in value) || value["tag"] === undefined) return false;
  if (value["tag"] !== "delineate_basins") return false;

  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("outputs" in value) || value["outputs"] === undefined) return false;
  return true;
}

export function DelineateBasinsSchemaFromJSON(json: any): DelineateBasinsSchema {
  return DelineateBasinsSchemaFromJSONTyped(json, false);
}

export function DelineateBasinsSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DelineateBasinsSchema {
  if (json == null) {
    return json;
  }
  return {
    tag: json["tag"],
    inputs: DelineateBasinsInputFromJSON(json["inputs"]),
    outputs: DelineateBasinsOutputFromJSON(json["outputs"]),
  };
}

export function DelineateBasinsSchemaToJSON(json: any): DelineateBasinsSchema {
  return DelineateBasinsSchemaToJSONTyped(json, false);
}

export function DelineateBasinsSchemaToJSONTyped(
  value?: DelineateBasinsSchema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tag: value["tag"],
    inputs: DelineateBasinsInputToJSON(value["inputs"]),
    outputs: DelineateBasinsOutputToJSON(value["outputs"]),
  };
}
